import { makeStyles } from '@material-ui/core/styles';

const screenWidth = window.innerWidth

const adminStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: '10px',
    position: 'absolute',
    width: screenWidth > 600 ? '65%' : '85%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  formControl: {
    minWidth: 120,
  },
  spacing: {
    marginBottom: '5px'
  },
  cancel: {
    backgroundColor: '#eb2929',
    color: 'white',
    marginLeft: '4px'
  },
  label: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  // table: {
  //   minWidth: 700,
  // },
  addUser: {
    backgroundColor: 'green'
  },
  addUserBtn: {
    backgroundColor: '#63d563',
    width: '30%',
    margin: '8px'
  },
  deleteUserBtn: {
    backgroundColor: '#d13939',
    width: screenWidth > 600 ? '75%' : '40%'
  },
  editUserBtn: {
    backgroundColor: '#566ee3',
    width: screenWidth > 600 ? '75%' : '40%'
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  confirmationPaper: {
    position: 'absolute',
    borderRadius: '10px',
    top: '35%',
    width: screenWidth > 600 ? '25%' : '50%',
    height: '15%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: '2px 4px 2px 4px'
  },
  lessPadding: {
    padding: '8px'
  }
}));

export default adminStyles